import { Component, ElementRef, Injector } from "@angular/core";
import { MeetingAgendaItem } from "@common/ADAPT.Common.Model/organisation/meeting-agenda-item";
import { Autobind } from "@common/lib/autobind.decorator/autobind.decorator";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { setReturnPathSearchParam } from "@common/ux/base-routed.component";
import { IMeetingAgendaItemComponent, MeetingAgendaItemComponent } from "@org-common/lib/meetings/meeting-agenda-component-registry";
import { lastValueFrom } from "rxjs";
import { switchMap } from "rxjs/operators";
import { VisionService } from "../vision.service";
import { VisionPageRoute } from "../vision-page/vision-page.component";

@MeetingAgendaItemComponent("adapt-assign-integrated-vision-meeting-agenda-item")
@Component({
    selector: "adapt-assign-integrated-vision-meeting-agenda-item",
    standalone: false,
    templateUrl: "./assign-integrated-vision-meeting-agenda-item.component.html",
})
export class AssignIntegratedVisionMeetingAgendaItemComponent extends BaseComponent implements IMeetingAgendaItemComponent {
    public meetingAgendaItem?: MeetingAgendaItem;
    public hasExistingVisions = false;
    public currentNominatedPersonId?: number;
    private teamId?: number;

    public constructor(
        elementRef: ElementRef,
        private injector: Injector,
        private visionService: VisionService,
    ) {
        super(elementRef);
    }

    public async onDataChanged() {
        if (this.meetingAgendaItem?.meeting) {
            this.teamId = this.meetingAgendaItem.meeting.teamId;
            const existingVisions = await lastValueFrom(this.visionService.getVisionsByTeam(this.teamId));
            this.hasExistingVisions = existingVisions.length > 0;
            this.currentNominatedPersonId = existingVisions.find((v) => v.extensions.isIntegrated)?.personId;
        }
    }

    @Autobind
    public assignIntegratedVision() {
        return this.visionService.assignIntegratedVision(this.teamId!).pipe(
            switchMap(() => this.onDataChanged()),
        );
    }

    @Autobind
    public gotoVisionPage() {
        const searchParams = setReturnPathSearchParam(
            this.injector,
            {},
            VisionPageRoute.id,
            "Return to meeting",
        );
        return VisionPageRoute.gotoRoute(
            { teamId: this.teamId! },
            searchParams,
        );
    }
}
